import { REACTIONS } from "../../utils/reactions";

// Pure presentational. Parent controls state.
//
// Props:
//   currentReaction: reaction key | null — the current user's reaction
//   counts: { likes, dislikes, hearts, party } — denormalized counts (partial ok)
//   onReact: (key) => void                 — toggle a reaction
//   onShowReactors: (key) => void          — open the who-reacted list for key
//   disabled: boolean
function ReactionButtons({ currentReaction, counts, onReact, onShowReactors, disabled }) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      {REACTIONS.map(({ key, label, countKey, Icon, activeClass }) => {
        const active = currentReaction === key;
        const n = counts?.[countKey] || 0;
        return (
          <button
            key={key}
            type="button"
            aria-label={label}
            disabled={disabled}
            onClick={() => onReact(key)}
            className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-[12.5px] font-medium border transition ${
              active
                ? activeClass
                : "bg-white border-gray-200 text-gray-600 hover:bg-gray-50"
            } disabled:opacity-50 disabled:cursor-not-allowed`}
          >
            <Icon size={14} strokeWidth={active ? 2.5 : 1.8} />
            <span
              role={n > 0 ? "button" : undefined}
              tabIndex={n > 0 ? 0 : undefined}
              onClick={(e) => {
                if (n <= 0) return;
                e.stopPropagation();
                onShowReactors?.(key);
              }}
              onKeyDown={(e) => {
                if (n <= 0) return;
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  e.stopPropagation();
                  onShowReactors?.(key);
                }
              }}
              className={n > 0 ? "hover:underline cursor-pointer" : ""}
            >
              {n}
            </span>
          </button>
        );
      })}
    </div>
  );
}

export default ReactionButtons;
